(function(){
  // mobile menu
  var burger=document.querySelector('[data-burger]'),nav=document.getElementById('nav');
  if(burger&&nav){burger.addEventListener('click',function(){var o=nav.classList.toggle('open');burger.setAttribute('aria-expanded',o)});}

  // collection sort
  var sort=document.querySelector('[data-sort]');
  if(sort){sort.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',sort.value);u.searchParams.delete('page');location.href=u.toString()});}

  // gallery
  var main=document.querySelector('[data-gal-main]');
  var thumbs=[].slice.call(document.querySelectorAll('[data-gal-thumb]'));
  function show(src,id){
    if(!main)return;
    main.removeAttribute('srcset');main.src=src;
    thumbs.forEach(function(t){t.setAttribute('aria-current',String(t.dataset.imgId==String(id)))});
  }
  thumbs.forEach(function(t){t.addEventListener('click',function(){show(t.dataset.galThumb,t.dataset.imgId)})});

  // product form
  var form=document.querySelector('[data-product-form]');
  if(form){
    var variants=JSON.parse(form.querySelector('[data-variants]').textContent);
    var idInput=form.querySelector('[name="id"]');
    var radios=[].slice.call(form.querySelectorAll('[data-opt]'));
    var btn=form.querySelector('[data-add]'),err=form.querySelector('[data-err]');
    var priceEl=document.querySelector('[data-price]');
    var money=function(c){return '€'+(c/100).toFixed(2).replace('.',',')};
    function sel(){var s=[];radios.forEach(function(r){if(r.checked)s[+r.dataset.opt]=r.value});return s}
    function find(s){return variants.find(function(v){return v.options.every(function(o,i){return o===s[i]})})}
    function update(changed){
      var s=sel(),v=find(s);
      if(!v&&changed){
        var idx=+changed.dataset.opt;
        v=variants.find(function(x){return x.options[idx]===changed.value&&x.available})||variants.find(function(x){return x.options[idx]===changed.value});
        if(v){radios.forEach(function(r){r.checked=(v.options[+r.dataset.opt]===r.value)});s=v.options.slice();}
      }
      radios.forEach(function(r){
        var i=+r.dataset.opt,t=s.slice();t[i]=r.value;
        var ok=variants.some(function(x){return x.available&&x.options.every(function(o,j){return j===i?o===r.value:(j<i?o===t[j]:true)})});
        r.disabled=!ok&&i>0;
      });
      document.querySelectorAll('[data-opt-label]').forEach(function(l){l.textContent=s[+l.dataset.optLabel]||''});
      if(!v){btn.disabled=true;btn.textContent='Unavailable';return}
      idInput.value=v.id;
      if(priceEl)priceEl.textContent=money(v.price);
      btn.disabled=!v.available;btn.textContent=v.available?'Add to cart':'Sold out';
      if(v.featured_image){
        var t=thumbs.find(function(x){return x.dataset.imgId==String(v.featured_image.id)});
        if(t)show(t.dataset.galThumb,t.dataset.imgId);
      }
      if(changed&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}
    }
    radios.forEach(function(r){r.addEventListener('change',function(){update(r)})});
    update();
    form.addEventListener('submit',function(e){
      e.preventDefault();err.textContent='';btn.disabled=true;var label=btn.textContent;btn.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+idInput.value,quantity:1}]})})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
        .then(function(){location.href='/cart'})
        .catch(function(j){err.textContent=(j&&j.description)||'Could not add this size. Try another one.';btn.disabled=false;btn.textContent=label});
    });
  }

  // cart quantities
  function change(line,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+line,quantity:Math.max(0,qty)})}).then(function(){location.reload()});
  }
  document.querySelectorAll('[data-step]').forEach(function(b){b.addEventListener('click',function(){var i=document.querySelector('[data-line-qty="'+b.dataset.line+'"]');change(b.dataset.line,(+i.value||0)+(+b.dataset.step))})});
  document.querySelectorAll('[data-line-qty]').forEach(function(i){i.addEventListener('change',function(){change(i.dataset.lineQty,+i.value||0)})});
  document.querySelectorAll('[data-remove]').forEach(function(b){b.addEventListener('click',function(){change(b.dataset.remove,0)})});
})();
